import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-chat-dialog-header',
  templateUrl: './chat-dialog-header.component.html',
  styleUrl: './chat-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, NgClass, TranslateModule, V2ButtonComponent]
})
export class ChatDialogHeaderComponent {
  title = input<string>('chat-bot.window.title');
  isFaqActive = input<boolean>(false);
  showFaqButton = input<boolean>(true);
  theme = input<string | null>(null);
  closePress = output();
  faqPress = output();

  themeClass = computed(() => {
    const theme = this.theme();
    return ['chat-dialog-header', theme ? `chat-dialog-header--${theme}` : ''];
  });

  faqLabel = computed(() => {
    const isFaqActive = this.isFaqActive();
    return isFaqActive ? 'chat-bot.window.chat' : 'chat-bot.window.faq';
  });

  icon = computed(() => {
    const isFaqActive = this.isFaqActive();
    return isFaqActive ? 'chat_bubble_outline' : 'help_outlined';
  });
}
